module.exports = __webpack_public_path__ + "img/orchid.070bd49f.png";